/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Shift } from './Shift';
import {
    ShiftFromJSON,
    ShiftFromJSONTyped,
    ShiftToJSON,
    ShiftToJSONTyped,
} from './Shift';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';

/**
 * 
 * @export
 * @interface SearchShiftsResponse
 */
export interface SearchShiftsResponse {
    /**
     * 
     * @type {Array<Shift>}
     * @memberof SearchShiftsResponse
     */
    data: Array<Shift>;
    /**
     * 
     * @type {Pagination}
     * @memberof SearchShiftsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the SearchShiftsResponse interface.
 */
export function instanceOfSearchShiftsResponse(value: object): value is SearchShiftsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function SearchShiftsResponseFromJSON(json: any): SearchShiftsResponse {
    return SearchShiftsResponseFromJSONTyped(json, false);
}

export function SearchShiftsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchShiftsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ShiftFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function SearchShiftsResponseToJSON(json: any): SearchShiftsResponse {
      return SearchShiftsResponseToJSONTyped(json, false);
  }

  export function SearchShiftsResponseToJSONTyped(value?: SearchShiftsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ShiftToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

